(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sb-frumosa-advertorial"]) return;
  try {
    
  (function () {
    if (customElements.get('sb-fr-buy-box')) return;

    class SbFrBuyBox extends HTMLElement {
      connectedCallback() {
        if (this.sbReady) return;
        this.sbReady = true;
        this.bindGallery();
        this.bindAccordion();
        this.bindBuy();
      }

      // Gallery: the main image and the thumbnails are two tracks that rotate
      // together. A step slides the track, then the DOM is reordered and the
      // transform reset, so the strip wraps forever with no cloned slides.
      bindGallery() {
        const main = this.querySelector('[data-sb-main-track]');
        const thumbs = this.querySelector('[data-sb-thumbs-track]');
        const viewport = this.querySelector('[data-sb-gallery-main]');
        const live = this.querySelector('[data-sb-gallery-live]');
        if (!main || main.children.length < 2) return;

        const count = main.children.length;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let busy = false;

        const stepOf = (track) => {
          const first = track.children[0].getBoundingClientRect();
          const second = track.children[1].getBoundingClientRect();
          return second.left - first.left;
        };

        // transitionend can be lost (backgrounded tab), so a timer backs it up
        const whenSettled = (track, done) => {
          let finished = false;
          const finish = (event) => {
            if (finished || (event && event.target !== track)) return;
            finished = true;
            track.removeEventListener('transitionend', finish);
            window.clearTimeout(timer);
            done();
          };
          const timer = window.setTimeout(finish, 700);
          track.addEventListener('transitionend', finish);
        };

        const rotate = (track, steps) => {
          const items = Array.from(track.children);
          if (steps > 0) {
            items.slice(0, steps).forEach((item) => track.appendChild(item));
          } else {
            items.slice(steps).reverse().forEach((item) => track.insertBefore(item, track.firstChild));
          }
        };

        const slide = (track, steps) =>
          new Promise((resolve) => {
            if (!track) return resolve();
            // With reduced motion no transition runs, so transitionend never fires
            if (reduceMotion.matches) {
              rotate(track, steps);
              return resolve();
            }
            const distance = stepOf(track) * Math.abs(steps);
            if (steps > 0) {
              track.style.transform = 'translateX(' + -distance + 'px)';
              whenSettled(track, () => {
                track.style.transition = 'none';
                rotate(track, steps);
                track.style.transform = '';
                void track.offsetWidth;
                track.style.transition = '';
                resolve();
              });
            } else {
              track.style.transition = 'none';
              rotate(track, steps);
              track.style.transform = 'translateX(' + -distance + 'px)';
              void track.offsetWidth;
              track.style.transition = '';
              track.style.transform = '';
              whenSettled(track, resolve);
            }
          });

        const sync = () => {
          Array.from(main.children).forEach((item, index) => {
            if (index === 0) item.removeAttribute('aria-hidden');
            else item.setAttribute('aria-hidden', 'true');
          });
          if (thumbs) {
            Array.from(thumbs.children).forEach((item, index) => {
              item.classList.toggle('is-active', index === 0);
              if (index === 0) item.setAttribute('aria-current', 'true');
              else item.removeAttribute('aria-current');
            });
          }
          if (live) live.textContent = Number(main.children[0].dataset.index) + 1 + ' / ' + count;
        };

        const go = (steps) => {
          if (busy || steps % count === 0) return;
          busy = true;
          Promise.all([slide(main, steps), slide(thumbs, steps)]).then(() => {
            sync();
            busy = false;
          });
        };

        if (thumbs) {
          thumbs.addEventListener('click', (event) => {
            const thumb = event.target.closest('.sb-bb__thumb');
            if (!thumb) return;
            go(Array.from(thumbs.children).indexOf(thumb));
          });
        }

        // Swipe on the main image. No pointer capture, and the axis is locked
        // by the browser through touch-action: pan-y on the viewport.
        if (viewport) {
          let startX = null;
          viewport.addEventListener('pointerdown', (event) => {
            startX = event.clientX;
          });
          const end = (event) => {
            if (startX === null) return;
            const delta = event.clientX - startX;
            startX = null;
            if (Math.abs(delta) > 40) go(delta < 0 ? 1 : -1);
          };
          viewport.addEventListener('pointerup', end);
          viewport.addEventListener('pointercancel', () => {
            startX = null;
          });
          viewport.addEventListener('pointerleave', end);
        }
      }

      // Accordion: one item open at a time. Height animates between 0 and the
      // measured content height, because the grid-rows trick fails in the
      // in-app browsers most ad traffic arrives in.
      bindAccordion() {
        const items = Array.from(this.querySelectorAll('[data-sb-acc-item]'));
        if (!items.length) return;

        const setOpen = (item, open) => {
          const trigger = item.querySelector('[data-sb-acc-trigger]');
          const panel = item.querySelector('[data-sb-acc-panel]');
          item.classList.toggle('is-open', open);
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
          if (open) panel.removeAttribute('inert');
          else panel.setAttribute('inert', '');
        };

        items.forEach((item) => {
          item.querySelector('[data-sb-acc-trigger]').addEventListener('click', () => {
            const willOpen = !item.classList.contains('is-open');
            items.forEach((other) => setOpen(other, other === item && willOpen));
          });
        });

        window.addEventListener('resize', () => {
          items.forEach((item) => {
            if (item.classList.contains('is-open')) setOpen(item, true);
          });
        });
      }

      // Items picked in the Kaching widget, in the shape /cart/add.js takes.
      // Falls back to one unit of the product if the widget is not there.
      selectedItems(button) {
        const block = this.querySelector('kaching-bundles-block');
        if (block && typeof block.items === 'function') {
          try {
            const items = block.items();
            if (Array.isArray(items) && items.length) {
              return items.map((item) => {
                const line = { id: item.id, quantity: item.quantity };
                if (item.properties) line.properties = item.properties;
                if (item.selling_plan) line.selling_plan = item.selling_plan;
                return line;
              });
            }
          } catch (error) {
            console.error('[sb-fr-buy-box] could not read the bundle items', error);
          }
        }
        return [{ id: Number(button.dataset.variantId), quantity: 1 }];
      }

      bindBuy() {
        const button = this.querySelector('[data-sb-buy]');
        const errorBox = this.querySelector('[data-sb-buy-error]');
        if (!button) return;

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const setLoading = (loading) => {
          button.classList.toggle('is-loading', loading);
          if (loading) button.setAttribute('aria-busy', 'true');
          else button.removeAttribute('aria-busy');
        };

        button.addEventListener('click', async () => {
          if (button.classList.contains('is-loading')) return;
          setLoading(true);
          if (errorBox) errorBox.hidden = true;

          try {
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: this.selectedItems(button) }),
            });
            if (!response.ok) {
              const data = await response.json().catch(() => ({}));
              throw new Error(data.description || data.message || '');
            }
            window.location.href = root + (this.dataset.redirect === 'cart' ? 'cart' : 'checkout');
          } catch (error) {
            console.error('[sb-fr-buy-box] add to cart failed', error);
            if (errorBox) {
              errorBox.textContent = error.message || this.dataset.errorMessage || '';
              errorBox.hidden = false;
            }
            setLoading(false);
          }
        });

        // Coming back from checkout with the browser back button restores the page as it was left
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) setLoading(false);
        });
      }
    }

    customElements.define('sb-fr-buy-box', SbFrBuyBox);
  })();

  } catch(e) { console.error(e); }
})();
})();
